import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type IdCheckStep = {
  id: string;
  label: string;
};

export const useIdSubmission = () => {
  const { t } = useTranslation('web-common');
  const [activeStep, setActiveStep] = useState<number>(0);
  const [emailVerified, setEmailVerified] = useState<boolean>(false);

  const steps: IdCheckStep[] = [
    {
      id: 'selfie-time',
      label: t('id-submission.steps.selfie-time.label'),
    },
    {
      id: 'id-scan',
      label: t('id-submission.steps.id-scan.label'),
    },
    {
      id: 'submited',
      label: t('id-submission.steps.submited.label'),
    },
  ];

  const handleNextStep = () => {
    setActiveStep((prevStep) => Math.min(prevStep + 1, steps.length - 1));
  };

  return {
    activeStep,
    emailVerified,
    handleNextStep,
    setEmailVerified,
    steps,
  };
};
